import axios, { AxiosError } from 'axios';
import { environment, svcPaths, oboAuthTokenUser, oboAuthTokenPassword, isInDebug } from '../apiClient/config';
import { OboToken } from './token.contracts';

class TokenApiClass {
    private ensureTrailingSlash(url: string): string {
        return url.endsWith('/') ? url : `${url}/`;
    }

    private encodeBase64(username: string, password: string): string {
        const credentials = `${username}:${password}`;
        return Buffer.from(credentials).toString('base64');
    }

    private validateInputs(clientToken: string, scope: string, username: string, password: string): void {
        if (!clientToken || !scope) {
            throw new Error('clientToken e scope sono obbligatori');
        }
        if (!username || !password) {
            throw new Error('username e password sono obbligatori');
        }
    }

    private buildApiUrl(baseURL: string): string {
        return `${this.ensureTrailingSlash(baseURL)}${svcPaths.users}/token/generate-obo-token`;
    }

    private handleApiError(error: unknown): never {
        if (axios.isAxiosError(error)) {
            const axiosError = error as AxiosError;
            if (axiosError.response) {
                // Server responded with a status code outside the 2xx range
                console.error(
                    `Errore API (${axiosError.response.status}):`,
                    axiosError.response.data
                );
            } else if (axiosError.request) {
                // No response received from the server
                console.error('Nessuna risposta dal server:', axiosError.request);
            } else {
                // Something else went wrong
                console.error('Errore durante la chiamata API:', axiosError.message);
            }
        } else if (error instanceof Error) {
            console.error('Errore generico:', error.message);
        } else {
            console.error('Errore sconosciuto:', error);
        }
        throw error;
    }

    async getOboToken(clientToken: string, scope: string): Promise<OboToken> {
          // Validazione degli input
        this.validateInputs(clientToken, scope, oboAuthTokenUser, oboAuthTokenPassword);

        // Codifica le credenziali in Base64
        const base64Credentials = this.encodeBase64(oboAuthTokenUser, oboAuthTokenPassword);

        // Determina l'URL base in base all'ambiente
        const baseURL = environment[window.location.host];
        if (!baseURL) {
            throw new Error(`Nessuna configurazione trovata per l'host: ${window.location.host}`);
        }

        // Applica la logica di debug
        const resolvedBaseURL = isInDebug(baseURL, svcPaths.users);
        if (!resolvedBaseURL) {
            throw new Error('Impossibile risolvere l\'URL del servizio utenti');
        }
       
        // Costruisce l'URL completo
        const apiURL = this.buildApiUrl(resolvedBaseURL);

        console.log('getOboToken url ' + apiURL + ' credential ' +  base64Credentials);

        try {
            // Effettua la chiamata API usando axios
            const response = await axios.post<OboToken>(apiURL, { clientToken, scope }, {
                headers: {
                    Authorization: `Basic ${base64Credentials}`,
                    'Content-Type': 'application/json', // Assicurati che il Content-Type sia impostato correttamente
                },
            });

            return response.data;
        } catch (error) {
            // Gestione degli errori
            this.handleApiError(error);
        }
    }
}

export const tokenApi = new TokenApiClass();